import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../css/about.css';

const Terms = () => {
  useEffect(() => {
    // Force header to be blue when component mounts
    const header = document.querySelector('.modern-header');
    if (header) {
      header.classList.remove('header-transparent');
      header.classList.add('header-scrolled');
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms of Service - Petro Choice Integrated Services</title>
        <meta name="description" content="Terms of Service for Petro Choice Integrated Services. Read our terms and conditions for using our services." />
        <meta name="keywords" content="terms of service, terms and conditions, Petro Choice, legal" />
      </Helmet>

      {/* Hero Section */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '400px', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' ,top: '-122px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="text-white mb-4" style={{ fontSize: '3rem', fontWeight: 'bold' }}>
                Terms of Service
              </h1>
              <p className="text-white-50 mb-0" style={{ fontSize: '1.2rem' }}>
                Terms and conditions for using our services
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container my-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow-sm border-0">
              <div className="card-body p-5">
                <div className="mb-4">
                  <h2 className="text-primary mb-3">1. Acceptance of Terms</h2>
                  <p className="text-muted">
                    By accessing and using the Petro Choice Integrated Services website and services, 
                    you accept and agree to be bound by the terms and provision of this agreement. 
                    If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">2. Description of Service</h2>
                  <p className="text-muted">
                    Petro Choice Integrated Services provides oil and gas industry services including:
                  </p>
                  <ul className="text-muted">
                    <li>Integrated Drilling Management</li>
                    <li>Wellhead Services</li>
                    <li>Manpower Supply</li>
                    <li>Technical Services</li>
                    <li>HSE Services</li>
                    <li>Supply Chain Management</li>
                    <li>And other related services</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">3. User Responsibilities</h2>
                  <p className="text-muted">
                    As a user of our services, you agree to:
                  </p>
                  <ul className="text-muted">
                    <li>Provide accurate and complete information</li>
                    <li>Maintain the security of your account credentials</li>
                    <li>Use our services only for lawful purposes</li>
                    <li>Not interfere with or disrupt our services</li>
                    <li>Comply with all applicable laws and regulations</li>
                    <li>Respect intellectual property rights</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">4. Intellectual Property</h2>
                  <p className="text-muted">
                    All content on this website, including but not limited to text, graphics, logos, 
                    images, and software, is the property of Petro Choice Integrated Services and is 
                    protected by copyright and other intellectual property laws. You may not reproduce, 
                    distribute, or create derivative works without our express written consent.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">5. Privacy and Data Protection</h2>
                  <p className="text-muted">
                    Your privacy is important to us. Our collection and use of personal information 
                    is governed by our Privacy Policy, which is incorporated into these Terms of Service 
                    by reference. By using our services, you consent to our collection and use of 
                    information as described in our Privacy Policy.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">6. Service Availability</h2>
                  <p className="text-muted">
                    We strive to maintain high availability of our services, but we do not guarantee 
                    uninterrupted access. We may temporarily suspend or restrict access to our services 
                    for maintenance, updates, or other operational reasons. We will provide reasonable 
                    notice when possible.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">7. Limitation of Liability</h2>
                  <p className="text-muted">
                    To the maximum extent permitted by law, Petro Choice Integrated Services shall not 
                    be liable for any indirect, incidental, special, consequential, or punitive damages, 
                    including but not limited to loss of profits, data, or use, arising out of or 
                    relating to your use of our services.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">8. Indemnification</h2>
                  <p className="text-muted">
                    You agree to indemnify and hold harmless Petro Choice Integrated Services, its 
                    officers, directors, employees, and agents from and against any claims, damages, 
                    obligations, losses, liabilities, costs, or debt arising from your use of our 
                    services or violation of these terms.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">9. Termination</h2>
                  <p className="text-muted">
                    We may terminate or suspend your access to our services immediately, without prior 
                    notice or liability, for any reason whatsoever, including without limitation if you 
                    breach the Terms. Upon termination, your right to use the service will cease immediately.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">10. Governing Law</h2>
                  <p className="text-muted">
                    These Terms shall be interpreted and governed by the laws of Egypt, without regard 
                    to its conflict of law provisions. Any disputes arising from these terms or your 
                    use of our services shall be resolved in the courts of Egypt.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">11. Severability</h2>
                  <p className="text-muted">
                    If any provision of these Terms is held to be unenforceable or invalid, such 
                    provision will be changed and interpreted to accomplish the objectives of such 
                    provision to the greatest extent possible under applicable law and the remaining 
                    provisions will continue in full force and effect.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">12. Changes to Terms</h2>
                  <p className="text-muted">
                    We reserve the right to modify or replace these Terms at any time. If a revision 
                    is material, we will provide at least 30 days notice prior to any new terms taking 
                    effect. What constitutes a material change will be determined at our sole discretion.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-primary mb-3">13. Contact Information</h2>
                  <p className="text-muted">
                    If you have any questions about these Terms of Service, please contact us at:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Email:</strong> legal@petrochoice.org</p>
                    <p className="mb-0"><strong>Address:</strong> Almaadadi–Takseem Allasilki–Hussein hamouda street 12A/2, Cairo, Egypt</p>
                  </div>
                </div>

                <div className="text-center mt-5">
                  <p className="text-muted">
                    <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
